<div *ngIf="searched && loading" class="dataLoader"></div>

<div *ngIf="count==0 && searched && !loading">
  <div class="alert alert-danger col-12 text-center" name="alert" role="alert">
    <i class="fa fa-search fa-2x"></i>
    <div>{{genericVisuals.nodata}}</div>
  </div>
</div>

<div *ngIf="searched && count>0 && !loading">
  <div class="card card-accent-warning shadowed">
    <div class="card-header" *ngIf="showHeader">
      <div class="row">
        <div
          class="col-md-5"
          [ngClass]="{'col-11': gridActions.length > 0, 'col-12': gridActions.length <= 0}"
        >
          <div class="card mb-0 p-0">
            <div class="card-block p-0 clearfix">
              <ul class="nav navbar-nav ml-auto">
                <li class="nav-item dropdown" dropdown>
                  <a
                    data-toggle="dropdown"
                    href="javascript:void(0);"
                    role="button"
                    aria-haspopup="true"
                    [ngClass]="{'link-disable': downloading}"
                    aria-expanded="false"
                    dropdownToggle
                  >
                    <i
                      class="fa fa-download btn-primary p-1 font-xl mr-1 pull-left"
                      [ngClass]="{'progress-loading': downloading}"
                    ></i>
                  </a>

                  <div class="h5 text-primary mb-0 pt-05" id="tableTotalCount">{{count}}</div>
                  <div class="text-muted text-uppercase font-weight-bold font-xs">
                    {{genericVisuals.records}}
                  </div>

                  <div
                    class="dropdown-menu dropdown-menu-left"
                    *dropdownMenu
                    aria-labelledby="simple-dropdown"
                  >
                    <a
                      class="dropdown-item"
                      href="javascript:void(0);"
                      (click)="parentMethodHandle('getTxt')"
                    >
                      <i class="fa fa-file-text-o text-default"></i>{{genericVisuals.text}}</a
                    >
                    <a
                      class="dropdown-item"
                      href="javascript:void(0);"
                      (click)="parentMethodHandle('getCsv')"
                    >
                      <i class="fa fa-file-text-o text-success"></i>{{genericVisuals.csv}}</a
                    >
                    <a
                      class="dropdown-item"
                      href="javascript:void(0);"
                      (click)="parentMethodHandle('getXls')"
                    >
                      <i class="fa fa-file-excel-o text-success"></i>{{genericVisuals.xls}}</a
                    >
                    <a
                      class="dropdown-item"
                      href="javascript:void(0);"
                      (click)="parentMethodHandle('getPdf')"
                    >
                      <i class="fa fa-file-pdf-o text-danger"></i>{{genericVisuals.pdf}}</a
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-1 offset-md-6" style="align-self: center;" *ngIf="gridActions.length > 0">
          <ul class="nav navbar-nav ml-auto">
            <li class="nav-item dropdown" dropdown>
              <a
                class="nav-link dropdown-toggle text-right"
                name="langs"
                data-toggle="dropdown"
                href="javascript:void(0);"
                role="button"
                aria-haspopup="true"
                [ngClass]="{'link-disable': checkboxLoading}"
                aria-expanded="false"
                dropdownToggle
              >
                <i class="fa fa-cog fa-2x" style="vertical-align: bottom"></i>
              </a>
              <div
                class="dropdown-menu dropdown-menu-right"
                *dropdownMenu
                aria-labelledby="simple-dropdown"
              >
                <a
                  *ngFor="let action of gridActions"
                  href="javascript:void(0);"
                  class="dropdown-item"
                  (click)="parentMethodHandle(action?.method)"
                  [ngClass]="{pagedisabled: renderBoolean(action?.disabled)}"
                >
                  <!-- [hidden]="renderBoolean(action?.hidden)"> -->
                  <i class="{{action?.iconClass}}"></i
                  >{{visuals[action?.tooltipKey] ? visuals[action?.tooltipKey] : genericVisuals[action?.tooltipKey]}}
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="card-block">
      <div class="row">
        <div class="col-12">
          <div class="table-responsive">
            <table class="table table-striped table-hover condensed">
              <thead>
                <tr class="text-brand-primary-1">
                  <th>#</th>
                  <th *ngIf="hasRowCheckbox && showHeader"></th>
                  <ng-container *ngFor="let map of columnMaps; let i = index">
                    <ng-template
                      *ngIf="showSort && map.hasOrder;then yesOrder else noOrder"
                    ></ng-template>
                    <ng-template #yesOrder>
                      <th
                        (click)="changeSort(map.sortOrder)"
                        [ngClass]="getSortState(map.sortOrder)"
                        [StyleCell]="map?.formatDefs?.format"
                      >
                        {{ visuals[map.columnKey] }}
                      </th>
                      <!-- <th *ngIf="map.hasOrder && columnMaps[0].actions?.length <= 0" (click)="changeSort(map.sortOrder)" [ngClass]="getSortState(map.sortOrder)" [StyleCell]="map.format">{{ visuals[map.columnKey] }}</th> -->
                    </ng-template>
                    <ng-template #noOrder>
                      <th [StyleCell]="map?.formatDefs?.format">{{ visuals[map.columnKey] }}</th>
                    </ng-template>
                  </ng-container>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let record of records; let rn = index"
                  id="tableRowCount"
                  [StyleRow]
                  [rowCondition]="record?.rowCondition"
                  [rowBgColor]="record?.rowBgColor"
                  [rowFontColor]="record?.rowFontColor"
                >
                  <th scope="row">{{rn+1}}</th>
                  <td
                    *ngIf="hasRowCheckbox && showHeader"
                    class="td-label td-label-muted text-center"
                  >
                    <ng-container *ngIf="record.hasRowCheckbox && !checkboxLoading">
                      <label class="csscheckbox csscheckbox-default"
                        ><input
                          type="checkbox"
                          id="{{'chk' + rn}}"
                          [ngModel]="strToBoolean(record.selected)"
                          (click)="parentMethodHandle('checkToggle',record)" /><span
                          class="fa fa-lg"
                        ></span
                      ></label>
                    </ng-container>
                    <div
                      class="checkboxLoader"
                      *ngIf="record.hasRowCheckbox && checkboxLoading"
                    ></div>
                  </td>
                  <td *ngFor="let map of record.columnMaps" [StyleCell]="map?.formatDefs?.format">
                    <span *ngIf="map.actions?.length > 0">
                      <span *ngIf="record.actionViewType > 0 && record.actionViewType < 3">
                        <span *ngFor="let action of map.actions">
                          <button
                            type="button"
                            class="{{action?.buttonClass}}"
                            (click)="parentMethodHandle(action?.method,record)"
                            [disabled]="action.isDisabled"
                            *ngIf="!action.isHidden"
                            tooltip="{{visuals[action?.tooltipKey]}}"
                          >
                            <i class="{{action?.iconClass}}"></i>
                          </button>
                        </span>
                      </span>

                      <div
                        *ngIf="record.actionViewType > 0 && record.actionViewType >= 3"
                        dropdown
                        container="body"
                      >
                        <a
                          data-toggle="dropdown"
                          href="javascript:void(0);"
                          role="button"
                          aria-haspopup="true"
                          aria-expanded="false"
                          dropdownToggle
                        >
                          <i class="fa fa-dots-three-vertical"></i>
                        </a>

                        <div
                          class="dropdown-menu dropdown-menu-left grid-button-drop"
                          *dropdownMenu
                          aria-labelledby="simple-dropdown"
                        >
                          <span *ngFor="let action of map.actions">
                            <button
                              type="button"
                              class="{{action?.buttonClass}}"
                              (click)="parentMethodHandle(action?.method,record)"
                              [disabled]="action.isDisabled"
                              *ngIf="!action.isHidden"
                              tooltip="{{visuals[action?.tooltipKey]}}"
                            >
                              <i class="{{action?.iconClass}}"></i>
                            </button>
                          </span>
                        </div>
                      </div>
                    </span>

                    <span *ngIf="map.actions?.length <= 0" [tooltip]="map?.formatDefs?.format == 'H' ? record.tooltipText : null">
                        {{ record[map.access(record)] | formatCell:map.formatDefs }}
                    </span>
                  </td>
                </tr>
              </tbody>
              <tfoot *ngIf="footer && (footer | json) != '{}'">
                <tr class="font-weight-bold text-brand-primary-1">
                  <th scope="row">{{genericVisuals.sum}}</th>
                  <td *ngIf="hasRowCheckbox"></td>

                  <td *ngFor="let map of columnMaps" [StyleCell]="map?.formatDefs?.format">
                    {{ footer[map.access(footer)] | formatCell:map.formatDefs }}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="card-footer" style="text-align: center;" *ngIf="showPagination">
      <div class="row">
        <div class="col-12">
          <nav aria-label="page result size" class="float-sm-none float-md-right">
            <ul class="pagination justify-content-start p-0 display-block">
              <li
                class="page-item"
                [ngClass]="{'active': pageSize == 20}"
                (click)="changePageSize(20)"
              >
                <a class="page-link" href="javascript:void(0);">20</a>
              </li>
              <li
                class="page-item"
                [ngClass]="{'active': pageSize == 50}"
                (click)="changePageSize(50)"
              >
                <a class="page-link" href="javascript:void(0);">50</a>
              </li>
              <li
                class="page-item"
                [ngClass]="{'active': pageSize == 100}"
                (click)="changePageSize(100)"
              >
                <a class="page-link" href="javascript:void(0);">100</a>
              </li>
            </ul>
          </nav>

          <form (ngSubmit)="changePage(pageNum,'full')">
            <nav aria-label="table page navigation" class="float-sm-none float-md-left">
              <ul class="pagination justify-content-center p-0 display-block">
                <li class="page-item" [ngClass]="{'disabled pagedisabled': pageNum == 1}">
                  <a
                    class="page-link"
                    aria-label="Previous"
                    (click)="changePage(pageNum,'prev')"
                    href="javascript:void(0);"
                  >
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">{{genericVisuals.previous}}</span>
                  </a>
                </li>
                <li class="page-item">
                  <input
                    class="form-control page-link text-center"
                    type="text"
                    id="pagination"
                    name="pagination"
                    size="2"
                    [(ngModel)]="pageNum"
                    pattern="^[1-9]\d*$"
                    oninvalid="setCustomValidity('Only numbers!')"
                  />
                </li>
                <li class="page-item disabled">
                  <a class="page-link" href="javascript:void(0);">{{pageMax}}</a>
                </li>

                <li class="page-item" [ngClass]="{'disabled pagedisabled': pageNum == pageMax}">
                  <a
                    class="page-link"
                    aria-label="Next"
                    (click)="changePage(pageNum,'next')"
                    href="javascript:void(0);"
                  >
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">{{genericVisuals.next}}</span>
                  </a>
                </li>
              </ul>
            </nav>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
